import { yupResolver } from "@hookform/resolvers/yup"
import React from "react"
import { useForm } from "react-hook-form"
import CustomButton from "../../../../ui/atoms/Button"
import CustomTextInput from "../../../../ui/atoms/CustomTextInput"
import ErrorLabel from "../../../../ui/atoms/ErrorLabel"
import PhoneInput from "../../../../ui/molecules/PhoneInput"
import { useLabels } from "../../../contents/hooks"
import { schema } from "./schema"

export interface PreRegistrationFormData {
  email: string
  phone: string
}

interface Props {
  defaultEmail?: string
  defaultPhone?: string
  // email: string
  // onEmailChange: (value: string) => void
  // phone: string
  // onPhoneChange: (value: string) => void
  onSubmit: (data: PreRegistrationFormData) => void
  loading?: boolean
  className?: string
}

const PreRegistrationForm = ({
  defaultEmail,
  defaultPhone,
  // email,
  // onEmailChange,
  // phone,
  // onPhoneChange,
  onSubmit,
  loading,
  className,
}: Props) => {
  const { getLabel } = useLabels()
  const { register, errors, handleSubmit } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      email: defaultEmail ?? "",
      phone: defaultPhone ?? "+39",
    } as any,
  })

  const submitData = handleSubmit(onSubmit)

  return (
    <div className={className}>
      <div className="mt-12">
        <CustomTextInput
          name="email"
          label={getLabel("common", "email")}
          fullWidth
          // value={email}
          // onChange={onEmailChange}
          autoComplete="off"
          onEnterKey={submitData}
          inputRef={register}
        />
        <ErrorLabel
          className="mt-2"
          error={!!errors.email}
          message={getLabel("forms", "invalid-field")}
        />
        <PhoneInput
          className="mt-2"
          name="phone"
          label={getLabel("common", "phone")}
          fullWidth
          inputRef={register}
          // value={phone}
          // onChange={onPhoneChange}
        />
        <ErrorLabel
          className="mt-2"
          error={!!errors.phone}
          message={getLabel("forms", "invalid-field")}
        />
      </div>
      <div className="mt-4">
        <CustomButton onClick={submitData} fullWidth loading={loading}>
          {getLabel("common", "continue")}
        </CustomButton>
      </div>
    </div>
  )
}

export default PreRegistrationForm
